<template>
  <b-container class="pt-2 pb-2" fluid>
    <Toast
      :title="toast.title"
      :content="toast.content"
      toaster="b-toaster-bottom-right"
      :onhiddenfunc="onHidden"
      :noautohide="true"
    />
    <div class="pb-2 text-center">
      <h1 class="mb-0">a hub for POIs</h1>
      <small class="text-secondary">
        <i>(<strong>POI</strong> - <strong>P</strong>oint <strong>O</strong>f <strong>I</strong>nterest)</i>
      </small>
    </div>
    <div>
      <div class="border rounded" style="background-color: #ececec;">
        <div class="p-2">
          <h4 class="mb-0 d-inline-block">
            Panoramas
            <sup>
              <b-icon-info-circle
                v-b-tooltip.hover.html
                title="Places with a view. It does not matter if it is in a city or on a mountain peak. Let the panorama speak for itself :)"
              />
            </sup>
          </h4>
          <b-link
            :to="{ name: 'pois-list', query: { category: 'panorama' } }"
            class="card-link d-inline-block float-right"
          >
            #panorama
          </b-link>
        </div>
        <Carousel imgWidth="1200" imgHeigth="300" :images="panoramas" id="panoramas" />
      </div>

      <div v-if="false">
        <b-card-group class="pt-2 pb-2" deck>
          <b-card no-body>
            <template v-slot:header>
              <h4 class="mb-0 d-inline-block">
                Panoramas
                <sup>
                  <b-icon-info-circle
                    v-b-tooltip.hover.html
                    title="Places with a view. It does not matter if it is in a city or on a mountain peak. Let the panorama speak for itself :)"
                  />
                </sup>
              </h4>
              <b-link :to="{ name: 'pois-list' }" class="card-link d-inline-block float-right">#panorama</b-link>
            </template>
            <b-card-body class="p-1">
              <Carousel imgWidth="1200" imgHeigth="300" />
            </b-card-body>
          </b-card>
        </b-card-group>
      </div>

      <b-card-group v-if="false" class="pt-2 pb-2" deck>
        <b-card no-body>
          <template v-slot:header>
            <h4 class="mb-0 d-inline-block">
              Obstructions
              <sup>
                <b-icon-info-circle
                  v-b-tooltip.hover.html
                  title="Something is blocking you moving forward?<br><small>E.g. Fallen tree, landslide, broken bridge, etc.</small>"
                />
              </sup>
            </h4>
            <a href="#" class="card-link d-inline-block float-right">#obstructions</a>
          </template>
          <b-card-body class="p-1">
            <Carousel imgWidth="600" imgHeigth="200" />
          </b-card-body>
        </b-card>

        <b-card no-body>
          <template v-slot:header>
            <h4 class="mb-0 d-inline-block">
              Restrictions
              <sup>
                <b-icon-info-circle
                  v-b-tooltip.hover.html
                  title="Noticed a restriction on a trail?<br><small>E.g. No MTB allowed, private property, etc.</small>"
                />
              </sup>
            </h4>
            <a href="#" class="card-link d-inline-block float-right">#restrictions</a>
          </template>
          <b-card-body class="p-1">
            <Carousel imgWidth="600" imgHeigth="200" />
          </b-card-body>
        </b-card>
      </b-card-group>
    </div>
  </b-container>
</template>

<script>
import Carousel from '@/components/Carousel';
import { BIconInfoCircle } from 'bootstrap-vue';
import Toast from '@/components/Toast';
import { mapGetters } from 'vuex';

export default {
  name: 'HomeView',
  components: { BIconInfoCircle, Carousel, Toast },
  data() {
    return {
      errors: [],
      slide: 0,
      toast: {
        title: 'Info',
        content: 'like to contribute some POIs? -> <i></i><a href="/login">Login</a></i>',
        variant: 'info',
      },
    };
  },
  computed: {
    ...mapGetters({ panoramas: 'poi/panoramas', showToastContribution: 'showToastContribution', user: 'auth/user' }),
  },
  mounted() {
    if (!this.user.loggedIn && this.showToastContribution) {
      // show contribution toast
      this.$bvToast.show('ph-toast');
    } else {
      // disable toast
      this.$store.commit('FLAG_CONTRIBUTION_OFF');
    }
    this.$store.dispatch('poi/getCarouselPois', { category: 'panorama' });
  },
  methods: {
    onHidden() {
      // disable toast
      this.$store.commit('FLAG_CONTRIBUTION_OFF');
    },
  },
};
</script>

<style scoped></style>
